/// <amd-module name="Test/TestPlansHubRefresh/TestCaseResultsPanel/Redux/TestCaseResultsPanelActions" />

import { ActionsUnion, createAction } from "redux/Utils/ActionHelper";
import { TestCaseResultsData } from "TestPlanCommon/Contracts/TestPlan";

export const TestCaseResultsPanelActions = {
    // dispatched to fetch all test case results for the given test case id
    fetchTestCaseResults: (testCaseId: number) => createAction(TestCaseResultsPanelActionsTypes.fetchTestCaseResults, { testCaseId }),

    // This action is used to open the test exeuction history for test case
    openTestExecutionHistory: (pointId: number, testCaseId: number) =>
        createAction(TestCaseResultsPanelActionsTypes.openTestExecutionHistory, { pointId, testCaseId }),

    // dispatched to open the runs page in a new tab for the given pointId, runId and resultId
    openRunsHub: (pointId: number, runId: number, resultId: number) => createAction(TestCaseResultsPanelActionsTypes.openRunsHub, { pointId, runId, resultId }),

    //invoke the reducer to update the test case results in the state
    fetchTestResultsSucceeded: (data: TestCaseResultsData) =>
        createAction(TestCaseResultsPanelActionsTypes.fetchTestResultsSucceeded, { data }),

    // invoke the reducer to show the in progress state for testcase results panel
    loadingInProgress: () => createAction(TestCaseResultsPanelActionsTypes.loadingInProgress)
};

export const enum TestCaseResultsPanelActionsTypes {
    fetchTestCaseResults = "TestCaseResultsPanel/fetchTestCaseResults",
    openTestExecutionHistory = "TestCaseResultsPanel/openTestExecutionHistory",
    openRunsHub = "TestCaseResultsPanel/openRunsHub",
    fetchTestResultsSucceeded = "TestCaseResultsPanel/fetchTestResultsSucceeded",
    loadingInProgress = "TestCaseResultsPanel/loadingInProgress"
}

export type TestCaseResultsPanelActions = ActionsUnion<typeof TestCaseResultsPanelActions>;
